import { Modal, truncateStyles } from '@sketch/components'
import styled from 'styled-components'

export const ModalBody = styled(Modal.Body)`
  flex-grow: 1;
  display: flex;
  justify-content: center;
`

export const FootnoteText = styled.span`
  ${truncateStyles};
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  flex-shrink: 1;
`
